import React from "react";
import "./GamesFilterStyle.scss";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "../Common_UI_Kit/EmblaArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import CustomButton from "../Common_UI_Kit/CustomButton";

const GamesFilter = ({ filtersText, activeIndex, setActiveIndex }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    slidesToScroll: "auto",
    align: "start"
  });

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="games-filter-section">
      <div className="games-filter-wrap">
        <div className="embla">
          {!prevBtnDisabled && (
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
          )}
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {filtersText.map((filter, index) => (
                <div className="embla__slide" key={index}>
                  <CustomButton
                    className={`filter-btn ${activeIndex === index ? "active" : ""}`}
                    onClick={() => setActiveIndex(index)}
                  >
                    {filter.filterNavText}
                  </CustomButton>
                </div>
              ))}
            </div>
          </div>
          {!nextBtnDisabled && (
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default GamesFilter;
